@import 'styles/mixins';
@import 'styles/variables';

.paymentForm {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.paymentDetails {
  padding: 0 20px;
}

.paymentDetailsHeader {
  @include lg-semibold;
  color: $grey-90;
  padding: 16px 0 16px;
  margin-bottom: 0;
}

.creditCardLabel {
  @include sm-regular;
  margin-bottom: 4px;
}

.cardField {
  background: var(--neutral-0);
  color: $grey-30;
  padding: 10px 16px 10px 10px;
  border: 1px solid $grey-20;
  border-radius: 6px;
  margin-bottom: 38px;
}

.buttonContainer {
  display: flex;
  justify-content: right;

  button:disabled {
    cursor: not-allowed;
  }
}

.leftArrow {
  margin-right: 8px;
  font-size: 15px;
}

.spin {
  stroke: white;
  fill: white;
  margin-right: 5px;

  div {
    background: conic-gradient(
      from 90deg at 50% 50%,
      rgba(143, 152, 169, 0) 0deg,
      #ffffff 359.96deg,
      rgba(143, 152, 169, 0) 360deg
    );

    &::after {
      background: none;
    }
  }
}
